import React, { useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Card, Tabs, Tab, Row, Col, Badge, Button } from 'react-bootstrap';
import { useQuery } from 'react-query';
import moment from 'moment';
import { LOPHUONGDANTHUCHANH_TRIENKHAI_GV_API } from '../../../utils/apiUrl';
import { URI_INTERNAL } from '../../../utils/pathLocations';
import { Get } from '../../../utils/httpProvider';

import InstructorScheduleThucHanhTab from './components/InstructorScheduleThucHanhTab';
import InstructorAttendanceThucHanhTab from './components/InstructorAttendanceThucHanhTab';
import BangDanhGiaThucHanhTab from './components/BangDanhGiaThucHanhTab';

const LopHuongDanThucHanhDetailGV = () => {
    const { id } = useParams();
    const history = useHistory();
    const [activeTab, setActiveTab] = useState('schedule');

    const { data: lopDetail, isLoading } = useQuery(
        ['lopHuongDanThucHanhDetailGV', id],
        () => Get(`${LOPHUONGDANTHUCHANH_TRIENKHAI_GV_API.GET_ITEM}/${id}`),
        { 
            enabled: !!id,
            staleTime: 0,
            cacheTime: 0
        }
    );

    if (isLoading) {
        return <div className="p-4 text-center">Đang tải thông tin lớp học...</div>;
    }

    if (!lopDetail) {
        return (
            <div className="p-4 text-center">
                <h5>Không tìm thấy lớp hướng dẫn thực hành.</h5>
                <Button variant="primary" onClick={() => history.push(URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_GV_PATH)}>
                    Quay lại danh sách
                </Button>
            </div>
        );
    }

    return (
        <div className="p-2 p-md-3">
            {/* DESKTOP VIEW (>= 768px) */}
            <div className="d-none d-md-block">
                {/* Header thông tin lớp dành cho Giảng Viên */}
                <Card className="shadow-sm border-0 mb-3">
                    <Card.Body>
                        <Row className="align-items-center">
                            <Col md={10}>
                                <div className="d-flex align-items-center mb-2">
                                    <Button
                                        variant="outline-secondary"
                                        size="sm"
                                        className="mr-3"
                                        onClick={() => {
                                            if (window.history.length > 1) {
                                                history.goBack();
                                            } else {
                                                history.push(URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_GV_PATH);
                                            }
                                        }}
                                    >
                                        <i className="fas fa-arrow-left mr-1"></i> Quay lại
                                    </Button>
                                    <h4 className="mb-0 text-success font-weight-bold">{lopDetail.tenKhoaHoc}</h4>
                                    <Badge variant="success" className="ml-2 font-weight-normal px-2 py-1">
                                        <i className="fas fa-chalkboard-teacher mr-1"></i> Giảng viên
                                    </Badge>
                                </div>
                                <div className="text-muted small">
                                    <span className="mr-3">
                                        <i className="fas fa-file-alt mr-1"></i>
                                        Số QĐ: <strong>{lopDetail.soQuyetDinh || "Chưa có"}</strong>
                                    </span>
                                    <span className="mr-3">
                                        <i className="fas fa-calendar-alt mr-1"></i>
                                        Khai giảng: <strong>{lopDetail.ngayKhaiGiang ? moment(lopDetail.ngayKhaiGiang).format('DD/MM/YYYY') : "—"}</strong>
                                    </span>
                                    <span className="mr-3">
                                        <i className="fas fa-calendar-check mr-1"></i>
                                        Bế giảng: <strong>{lopDetail.ngayBeGiang ? moment(lopDetail.ngayBeGiang).format('DD/MM/YYYY') : "—"}</strong>
                                    </span>
                                    <span className="mr-3">
                                        <i className="fas fa-users mr-1"></i>
                                        Học viên: <strong>{lopDetail.soLuongHocVienThucTe || 0}</strong>
                                    </span>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                {/* Các Tabs nghiệp vụ Giảng Viên Desktop */}
                <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="custom-nav-tabs mb-3">
                    <Tab
                        eventKey="schedule"
                        title={
                            <span>
                                <i className="fas fa-calendar-alt mr-1"></i> Lịch Giảng Dạy & Thời Khóa Biểu
                            </span>
                        }
                    >
                        <InstructorScheduleThucHanhTab lopId={id} />
                    </Tab>

                    <Tab
                        eventKey="instructor_attendance"
                        title={
                            <span>
                                <i className="fas fa-user-check mr-1"></i> Điểm Danh Lớp Học
                            </span>
                        }
                    >
                        <InstructorAttendanceThucHanhTab lopId={id} />
                    </Tab>

                    <Tab
                        eventKey="danhgia"
                        title={
                            <span>
                                <i className="fas fa-file-signature mr-1"></i> Bảng Đánh Giá Theo Đợt
                            </span>
                        }
                    >
                        <BangDanhGiaThucHanhTab lopId={id} />
                    </Tab>
                </Tabs>
            </div>

            {/* MOBILE VIEW (< 768px) CHUẨN ĐÀO TẠO LIÊN TỤC */}
            <div className="d-block d-md-none">
                {/* Mobile Top App Bar */}
                <div className="d-flex align-items-center justify-content-between mb-2 px-1">
                    <div
                        className="d-flex align-items-center text-dark font-weight-bold"
                        style={{ fontSize: '16px', cursor: 'pointer' }}
                        onClick={() => {
                            if (window.history.length > 1) {
                                history.goBack();
                            } else {
                                history.push(URI_INTERNAL.TRIENKHAI_HUONGDANTHUCHANH_GV_PATH);
                            }
                        }}
                    >
                        <i className="fas fa-chevron-left mr-2" style={{ fontSize: '15px' }}></i>
                        <span>
                            {activeTab === 'schedule'
                                ? 'Lịch giảng dạy'
                                : activeTab === 'instructor_attendance'
                                ? 'Điểm danh lớp'
                                : 'Bảng đánh giá theo đợt'}
                        </span>
                    </div>
                    <div className="text-muted" style={{ cursor: 'pointer', padding: '4px 8px' }}>
                        <i className="fas fa-ellipsis-h" style={{ fontSize: '16px' }}></i>
                    </div>
                </div>

                {/* Mobile Class Card Banner */}
                <div className="bg-white rounded-lg p-3 mb-2 border shadow-sm" style={{ borderRadius: '12px', borderColor: '#e2e8f0' }}>
                    <div className="font-weight-bold mb-1" style={{ color: '#16a34a', fontSize: '15px', lineHeight: '1.3' }}>
                        {lopDetail.tenKhoaHoc}
                    </div>
                    <div className="text-muted small mb-2" style={{ fontSize: '12px' }}>
                        {lopDetail.soQuyetDinh ? `${lopDetail.soQuyetDinh} · ` : ''}
                        Khai giảng {lopDetail.ngayKhaiGiang ? moment(lopDetail.ngayKhaiGiang).format('DD/MM/YYYY') : '—'} · {lopDetail.soLuongHocVienThucTe || 0} học viên
                    </div>
                    <div>
                        <span
                            className="badge px-2 py-1 font-weight-500"
                            style={{
                                backgroundColor: '#dcfce7',
                                color: '#15803d',
                                borderRadius: '6px',
                                fontSize: '11px'
                            }}
                        >
                            Giảng viên hướng dẫn
                        </span>
                    </div>
                </div>

                {/* Mobile Tabs Bar */}
                <div
                    className="d-flex overflow-auto mb-3 bg-white border-bottom"
                    style={{ whiteSpace: 'nowrap', WebkitOverflowScrolling: 'touch', gap: '4px' }}
                >
                    <button
                        type="button"
                        className={`btn btn-sm py-2 px-3 font-weight-500 border-0 ${activeTab === 'schedule' ? 'text-success border-bottom border-success font-weight-bold' : 'text-muted'}`}
                        style={{
                            borderRadius: 0,
                            borderBottom: activeTab === 'schedule' ? '2px solid #16a34a' : 'none',
                            fontSize: '13px'
                        }}
                        onClick={() => setActiveTab('schedule')}
                    >
                        Lịch dạy
                    </button>
                    <button
                        type="button"
                        className={`btn btn-sm py-2 px-3 font-weight-500 border-0 ${activeTab === 'instructor_attendance' ? 'text-success border-bottom border-success font-weight-bold' : 'text-muted'}`}
                        style={{
                            borderRadius: 0,
                            borderBottom: activeTab === 'instructor_attendance' ? '2px solid #16a34a' : 'none',
                            fontSize: '13px'
                        }}
                        onClick={() => setActiveTab('instructor_attendance')}
                    >
                        Điểm danh
                    </button>
                    <button
                        type="button"
                        className={`btn btn-sm py-2 px-3 font-weight-500 border-0 ${activeTab === 'danhgia' ? 'text-success border-bottom border-success font-weight-bold' : 'text-muted'}`}
                        style={{
                            borderRadius: 0,
                            borderBottom: activeTab === 'danhgia' ? '2px solid #16a34a' : 'none',
                            fontSize: '13px'
                        }}
                        onClick={() => setActiveTab('danhgia')}
                    >
                        Đánh giá
                    </button>
                </div>

                {/* Mobile Tab Content */}
                <div>
                    {activeTab === 'schedule' && <InstructorScheduleThucHanhTab lopId={id} />}
                    {activeTab === 'instructor_attendance' && <InstructorAttendanceThucHanhTab lopId={id} />}
                    {activeTab === 'danhgia' && <BangDanhGiaThucHanhTab lopId={id} />}
                </div>
            </div>
        </div>
    );
};

export default LopHuongDanThucHanhDetailGV;
